import { Component } from '@angular/core';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { RejectedFiles } from '@app/utils/file-checker';

interface FileRejectedDialogInput {
  rejectedFiles: RejectedFiles;
}

@Component({
  selector: 'portal-file-rejected-dialog',
  templateUrl: './file-rejected-dialog.component.html',
  styles: [],
  standalone: false,
})
export class FileRejectedDialogComponent
  extends DialogComponent<FileRejectedDialogInput, void>
  implements FileRejectedDialogInput
{
  rejectedFiles!: RejectedFiles;
}
